import { IconType } from "./icons.types";

export const PdfIcon = ({ className }: IconType) => {
  return (
    <svg
      width="40"
      height="39"
      viewBox="0 0 40 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M32.5514 37.4006H16.0688C12.945 37.4006 10.4126 34.8683 10.4126 31.7444V7.30549C10.4126 4.18167 12.945 1.6493 16.0688 1.6493H26.2726L38.2076 13.5842V31.7444C38.2076 34.8683 35.6752 37.4006 32.5514 37.4006Z"
        fill="#EEF1F7"
        stroke="#CBD0DC"
        strokeWidth="2.26248"
      />
      <rect
        y="17.3149"
        width="26.5213"
        height="15.4707"
        rx="3.95933"
        fill="#D82042"
      />
      <path
        d="M4.39464 28.8074V21.4136H7.03012C7.60536 21.4136 8.08191 21.5183 8.45978 21.7277C8.83766 21.9371 9.12046 22.2235 9.30819 22.5869C9.49593 22.9479 9.58979 23.3547 9.58979 23.8072C9.58979 24.2621 9.49472 24.6712 9.30458 25.0347C9.11685 25.3957 8.83284 25.6821 8.45256 25.8939C8.07469 26.1033 7.59934 26.208 7.02651 26.208H5.21416V25.2621H6.92542C7.28886 25.2621 7.58369 25.1995 7.80994 25.0744C8.03618 24.9468 8.20225 24.7735 8.30815 24.5545C8.41405 24.3355 8.467 24.0864 8.467 23.8072C8.467 23.528 8.41405 23.2801 8.30815 23.0635C8.20225 22.8468 8.03498 22.6772 7.80633 22.5544C7.58008 22.4317 7.28164 22.3703 6.91098 22.3703H5.5102V28.8074H4.39464Z"
        fill="white"
      />
      <path
        d="M13.2912 28.8074H10.8976V21.4136H13.367C14.0915 21.4136 14.7136 21.5616 15.2335 21.8576C15.7534 22.1513 16.1517 22.5737 16.4285 23.1248C16.7077 23.6736 16.8473 24.3319 16.8473 25.0996C16.8473 25.8698 16.7065 26.5317 16.4249 27.0853C16.1457 27.6389 15.7414 28.0649 15.2119 28.3633C14.6824 28.6594 14.0421 28.8074 13.2912 28.8074ZM12.0132 27.8326H13.2298C13.793 27.8326 14.2612 27.7267 14.6342 27.5149C15.0073 27.3007 15.2865 26.9914 15.4718 26.5871C15.6571 26.1803 15.7498 25.6845 15.7498 25.0996C15.7498 24.5196 15.6571 24.0274 15.4718 23.623C15.2889 23.2187 15.0157 22.9118 14.6523 22.7024C14.2888 22.493 13.8376 22.3883 13.2984 22.3883H12.0132V27.8326Z"
        fill="white"
      />
      <path
        d="M18.2345 28.8074V21.4136H22.8196V22.3739H19.3501V24.6267H22.491V25.5834H19.3501V28.8074H18.2345Z"
        fill="white"
      />
    </svg>
  );
};
